import { useNavigate } from '@tanstack/react-router';
import moment from 'moment';

import { useAppStore } from '@common/stores/useAppStore';
import { Button } from '@common/ui/buttons/Button';

import { useAuthStore } from '@entities/auth/stores/useAuthStore';

import { MatchmakerResult } from '../MatchmakerResult';

export type SwipeLimitResultProps = {
  resetTime: string | null;
};

/**
 * The dating deck's «Свайпы закончились» screen: skips and recommendations
 * spend the same swipes, so the matchmaker gets the same way out.
 */
export const SwipeLimitResult = ({ resetTime }: SwipeLimitResultProps) => {
  const navigate = useNavigate();
  const { tasks } = useAppStore();
  const user = useAuthStore((state) => state.user);
  const storedResetTime = useAuthStore(
    (state) => state.swipe_status?.reset_time ?? null,
  );

  const activeTasksCount = (tasks ?? []).filter(
    (task) => task.status === 'available',
  ).length;
  const timeLeft = moment(resetTime ?? storedResetTime).fromNow(true);
  const isPremium = !!user?.is_premium;

  return (
    <MatchmakerResult
      testId="matchmaker-swipe-limit"
      icon3d="sand-clock.png"
      title="Свайпы закончились"
      description={
        <>
          Новые появятся через {timeLeft}.
          <br />
          {activeTasksCount > 0
            ? 'Чтобы не ждать, выполни задания или подключи Premium'
            : 'Чтобы не ждать, подключи Premium'}
        </>
      }
      button={
        (activeTasksCount > 0 || !isPremium) && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 8,
              width: '100%',
            }}
          >
            {activeTasksCount > 0 && (
              <Button
                testId="matchmaker-swipe-limit-tasks-button"
                variant="premiumGradient"
                size={1000}
                onClick={() => navigate({ to: '/tasks' })}
              >
                Выполнить задания
              </Button>
            )}
            {!isPremium && (
              <Button
                testId="matchmaker-swipe-limit-premium-button"
                variant={
                  activeTasksCount > 0 ? 'actionSecondary' : 'premiumGradient'
                }
                size={1000}
                onClick={() => navigate({ to: '/premium' })}
              >
                Подключить Premium
              </Button>
            )}
          </div>
        )
      }
    />
  );
};
